import { CircleAlert } from "lucide-react";
import { number, money, date } from "./purchase-order-presentation";
import type { PurchaseOrdersViewState } from "./purchase-order-view-state";

type Props = Pick<PurchaseOrdersViewState, "isRolePreview" | "dispatchRecipient" | "deliveryAddress" | "setDeliveryAddress"> & { dialog: Extract<NonNullable<PurchaseOrdersViewState["dialog"]>, { kind: "send"; }>; };

export function PurchaseOrderSendFields({ isRolePreview, dispatchRecipient, dialog, deliveryAddress, setDeliveryAddress }: Props) {
  return (<>
    <>
      <div
        className={`purchase-order-dispatch-notice ${isRolePreview ? "is-demo" : "is-live"}`}
      >
        <CircleAlert size={18} />
        <div>
          <strong>
            {isRolePreview
              ? "Demo gönderimi"
              : "Gerçek e-posta gönderimi"}
          </strong>
          <span>
            {isRolePreview
              ? "Bu işlem hiçbir e-posta adresine ileti göndermez; yalnızca demo sipariş durumunu ilerletir."
              : "Doğrulanmış sipariş kişisine Microsoft Graph üzerinden güvenli teyit bağlantısı gönderilir."}
          </span>
        </div>
      </div>
      <section
        className="purchase-order-email-preview"
        aria-label="Gönderilecek e-posta önizlemesi"
      >
        <header>
          <div>
            <span>ANL TEDARİK</span>
            <strong>Satın alma siparişi</strong>
          </div>
          <small>
            {isRolePreview
              ? "Demo önizlemesi"
              : "Gönderilecek içerik"}
          </small>
        </header>
        <div className="purchase-order-email-meta">
          <span>
            <small>Kime</small>
            <strong>
              {dispatchRecipient.trim() ||
                "Doğrulanmış sipariş iletişim kişisi"}
            </strong>
          </span>
          <span>
            <small>Konu</small>
            <strong>
              {dialog.order.orderNo} numaralı satın alma siparişi
            </strong>
          </span>
        </div>
        <div className="purchase-order-email-body">
          <p>Sayın {dialog.order.supplierName},</p>
          <p>
            Siparişi güvenli bağlantı üzerinden inceleyerek kabul, ret
            veya değişiklik talebinizi ve teslimat planınızı
            iletebilirsiniz.
          </p>
          <dl>
            <div>
              <dt>Ürün / ihtiyaç</dt>
              <dd>{dialog.order.requestTitle}</dd>
            </div>
            <div>
              <dt>Miktar</dt>
              <dd>
                {number(dialog.order.orderedQuantity)}{" "}
                {dialog.order.unit}
              </dd>
            </div>
            <div>
              <dt>Teklif</dt>
              <dd>
                {dialog.order.selectedOfferNo} · Sürüm{" "}
                {dialog.order.offerVersion}
              </dd>
            </div>
            <div>
              <dt>Toplam</dt>
              <dd>
                {money(
                  dialog.order.totalAmount,
                  dialog.order.currency,
                )}
              </dd>
            </div>
            <div>
              <dt>Ödeme</dt>
              <dd>{dialog.order.paymentDays} gün</dd>
            </div>
            <div>
              <dt>Beklenen teslimat</dt>
              <dd>{date(dialog.order.expectedDeliveryAt)}</dd>
            </div>
          </dl>
          <address>
            <span>Teslimat adresi</span>
            <strong>
              {deliveryAddress.trim() || "Teslimat adresi girilmedi"}
            </strong>
          </address>
        </div>
      </section>
      <div className="purchase-order-form">
        <label className="form-field-wide">
          Sipariş iletişim kişisi
          <input
            type="email"
            value={dispatchRecipient}
            readOnly
            placeholder="Tedarikçi kartından otomatik alınır"
          />
          <small>
            Alıcı, tedarikçi kartındaki birincil ve doğrulanmış
            “Sipariş” kişisinden sunucu tarafından seçilir.
          </small>
        </label>
        <label className="form-field-wide">
          Teslimat adresi
          <textarea
            rows={3}
            value={deliveryAddress}
            onChange={(event) =>
              setDeliveryAddress(event.target.value)
            }
            placeholder="Teslimatın yapılacağı açık adres"
          />
        </label>
        <div className="purchase-order-next-step-note form-field-wide">
          {isRolePreview
            ? "Demo gönderimi tamamlandığında sipariş yalnızca önizleme verisinde “Tedarikçiye iletildi” durumuna geçer."
            : "E-posta sağlayıcısı gönderimi doğrularsa sipariş “Tedarikçiye iletildi” ve teyit “Yanıt bekleniyor” durumuna geçer. Başarısız olursa taslak korunur."}
        </div>
      </div>
    </>
  </>);
}
